<script>
  import GamePositionItem from "./GamePositionItem.svelte";

  export let filters = {};

  const allGames = [
    {
      id: 1,
      name: "Babel Builder",
      provider: "Pgi",
      type: "ORIGINAL",
      image: "https://placehold.co/60x60?text=BB",
    },
    {
      id: 2,
      name: "Babel Riches",
      provider: "Pgi",
      type: "ORIGINAL",
      image: "https://placehold.co/60x60?text=BR",
    },
    {
      id: 3,
      name: "Cash Joker",
      provider: "sw",
      type: "RÉPLICA",
      image: "https://placehold.co/60x60?text=CJ",
    },
    {
      id: 4,
      name: "Cheshire's Luck",
      provider: "Pgi",
      type: "RÉPLICA",
      image: "https://placehold.co/60x60?text=CL",
    },
    {
      id: 5,
      name: "Chessmas",
      provider: "Directo",
      type: "ORIGINAL",
      image: "https://placehold.co/60x60?text=CH",
    },
    {
      id: 6,
      name: "Clash of Heroes",
      provider: "Pgi",
      type: "RÉPLICA",
      image: "https://placehold.co/60x60?text=COH",
    },
    {
      id: 7,
      name: "Cleopatra's Diary",
      provider: "Directo",
      type: "ORIGINAL",
      image: "https://placehold.co/60x60?text=CD",
    },
    {
      id: 8,
      name: "Dynamite Boost",
      provider: "Directo",
      type: "ORIGINAL",
      image: "https://placehold.co/60x60?text=DB",
    },
    {
      id: 9,
      name: "Electric Elements",
      provider: "Directo",
      type: "ORIGINAL",
      image: "https://placehold.co/60x60?text=EE",
    },
    {
      id: 10,
      name: "Elysium VIP",
      provider: "Directo",
      type: "ORIGINAL",
      image: "https://placehold.co/60x60?text=EV",
    },
  ];

  // Juegos que aparecerán inicialmente en la tabla derecha.
  let selectedGames = allGames.slice(0, 10);

  $: availableGames = allGames.filter(
    (game) => !selectedGames.some((selected) => selected.id === game.id)
  );

  // Aplicamos los filtros recibidos desde el componente padre.
  $: filteredAvailableGames = availableGames.filter((game) => {
    const search = (filters.search || "").trim().toLowerCase();

    const matchesSearch =
      !search ||
      game.name.toLowerCase().includes(search);

    const matchesProvider =
      !filters.provider ||
      String(game.provider).toLowerCase() ===
        String(filters.provider).toLowerCase();

    return matchesSearch && matchesProvider;
  });

  function addGame(game) {
    if (selectedGames.some((item) => item.id === game.id)) return;

    selectedGames = [...selectedGames, game];
  }

  function removeGame(game) {
    selectedGames = selectedGames.filter(
      (item) => item.id !== game.id
    );
  }

  let draggedGameId = null;

  function handleDragStart(event, game) {
    draggedGameId = game.id;

    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("text/plain", String(game.id));
  }

  function handleDragOver(event) {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }

  function handleDrop(event, targetGame) {
    event.preventDefault();

    const draggedId = Number(
      event.dataTransfer.getData("text/plain")
    ) || draggedGameId;

    if (draggedId === null || draggedId === targetGame.id) return;

    const updatedGames = [...selectedGames];

    const fromIndex = updatedGames.findIndex(
      (game) => game.id === draggedId
    );

    const toIndex = updatedGames.findIndex(
      (game) => game.id === targetGame.id
    );

    if (fromIndex === -1 || toIndex === -1) return;

    const [movedGame] = updatedGames.splice(fromIndex, 1);

    updatedGames.splice(toIndex, 0, movedGame);

    selectedGames = updatedGames;
    draggedGameId = null;
  }

  function saveChanges() {
    const result = selectedGames.map((game, index) => ({
      ...game,
      position: index + 1,
    }));

    console.log("Juegos seleccionados:", result);
  }
</script>

<div class="games-container">
  <!-- JUEGOS DISPONIBLES -->
  <section class="games-panel">
    <div class="panel-header">
      <strong>Juegos disponibles</strong>
    </div>

    <div class="games-list">
      {#each filteredAvailableGames as game (game.id)}
        <GamePositionItem
          {game}
          action="add"
          on:action={() => addGame(game)}
        />
      {:else}
        <p class="empty-message">
          No hay juegos disponibles.
        </p>
      {/each}
    </div>
  </section>

  <!-- JUEGOS SELECCIONADOS -->
  <section class="games-panel">
    <div class="panel-header">
      <strong>Juegos seleccionados</strong>

      <button class="settings-button" title="Configuración">
        <i class="fa-solid fa-gear"></i>
      </button>
    </div>

    <div class="games-list">
      {#each selectedGames as game, index (game.id)}
        <div
          class:dragging={draggedGameId === game.id}
          on:dragover={handleDragOver}
          on:drop={(event) => handleDrop(event, game)}
        >
          <GamePositionItem
            {game}
            action="remove"
            position={index + 1}
            draggable={true}
            on:action={() => removeGame(game)}
            on:dragstart={(event) => handleDragStart(event, game)}
          />
        </div>
      {:else}
        <p class="empty-message">
          Todavía no has seleccionado juegos.
        </p>
      {/each}
    </div>
  </section>
</div>

<div class="manager-actions">
  <button class="cancel-button" on:click={() => console.log("Cancelar")}>
    Cancelar
  </button>

  <button class="save-button" on:click={saveChanges}>
    Guardar cambios
  </button>
</div>

<style>
  .games-container {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
    margin-top: 24px;
  }

  .games-panel {
    min-width: 0;
    border: 1px solid #dee2e6;
  }

  .panel-header {
    min-height: 43px;
    padding: 10px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #212529;
    color: white;
    font-size: 13px;
  }

  .games-list {
    min-height: 40px;
  }

  .settings-button {
    width: 32px;
    height: 32px;
    background: transparent;
    border: 1px solid white;
    color: white;
    font-size: 20px;
    cursor: pointer;
  }

  .dragging {
    opacity: 0.5;
  }

  .empty-message {
    padding: 20px;
    text-align: center;
    color: #6c757d;
  }

  .manager-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 20px;
  }

  .cancel-button,
  .save-button {
    padding: 8px 16px;
    border-radius: 7px;
    cursor: pointer;
  }

  .cancel-button {
    background: white;
    border: 1px solid #343a40;
  }

  .save-button {
    color: white;
    background: #ff0090;
    border: 1px solid #ff0090;
  }

  @media (max-width: 900px) {
    .games-container {
      grid-template-columns: 1fr;
    }
  }
</style>